import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { CardContent, Tooltip } from '@mui/material';
import { currenciesMap } from 'lib/constants/currencies';

import {
  Amount,
  AmountContainer,
  Card,
  CardTitle,
  InfoIcon,
} from './styles';

interface AmountCardProps {
  title: React.ReactNode
  tooltip: React.ReactNode
  value: number
  currency: string
}

function AmountCard(props: AmountCardProps) {
  const {
    currency,
    title,
    tooltip,
    value,
  } = props;

  return (
    <Card>
      <CardContent>
        <CardTitle>
          {title}
          <Tooltip placement="top" arrow title={tooltip}>
            <InfoIcon icon={faInfoCircle} />
          </Tooltip>
        </CardTitle>
        <AmountContainer>
          <Amount>
            {value / 100}
            {`${currenciesMap[currency.toUpperCase()]?.symbol} ${currency}`}
          </Amount>
        </AmountContainer>
      </CardContent>
    </Card>
  );
}

export default AmountCard;
